"use client"
import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"
import { useLanguage } from "../../context/LanguageContext"
import {
  LogOut,
  User,
  Home,
  Video,
  Menu,
  X
} from "lucide-react"
import SimpleLanguageSwitcher from "./SimpleLanguageSwitcher"

const Header = () => {
  const { user, logout } = useAuth()
  const { t } = useLanguage()
  const navigate = useNavigate()
  const [menuOpen, setMenuOpen] = useState(false)

  const handleLogout = () => {
    logout()
    navigate("/")
    setMenuOpen(false)
  }

  const toggleMenu = () => {
    setMenuOpen(!menuOpen)
  }

  return (
    <header className="bg-blue-600 text-white shadow-lg">
      <div className="container mx-auto px-4 py-4">
        <div className="flex justify-between items-center">
          <Link to="/" className="text-2xl font-bold">
            DonationApp
          </Link>

          {/* Mobile Menu Toggle */}
          <div className="lg:hidden">
            <button onClick={toggleMenu} className="focus:outline-none">
              {menuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex items-center space-x-6">
            <Link to="/" className="flex items-center space-x-1 hover:text-blue-200">
              <Home size={18} />
              <span>{t("header.home")}</span>
            </Link>

            <Link to="/videos" className="flex items-center space-x-1 hover:text-blue-200">
              <Video size={18} />
              <span>{t("header.videos")}</span>
            </Link>

            {user ? (
              <div className="flex items-center space-x-4">
                <Link
                  to={user.is_admin ? "/admin" : "/dashboard"}
                  className="flex items-center space-x-1 hover:text-blue-200"
                >
                  <User size={18} />
                  <span>{user.is_admin ? t("header.adminPanel") : t("header.dashboard")}</span>
                </Link>

                <button onClick={handleLogout} className="flex items-center space-x-1 hover:text-blue-200">
                  <LogOut size={18} />
                  <span>{t("header.logout")}</span>
                </button>
              </div>
            ) : (
              <div className="flex items-center space-x-4">
                <Link to="/login" className="hover:text-blue-200">
                  {t("header.login")}
                </Link>
                <Link to="/register" className="bg-blue-500 px-4 py-2 rounded hover:bg-blue-400">
                  {t("header.register")}
                </Link>
              </div>
            )}

            <SimpleLanguageSwitcher />
          </nav>
        </div>

        {/* Mobile Nav */}
        {menuOpen && (
          <div className="lg:hidden mt-4 space-y-3">
            <Link to="/" className="block text-white hover:text-blue-200" onClick={toggleMenu}>
              <Home size={18} className="inline mr-2" />
              {t("header.home")}
            </Link>

            <Link to="/videos" className="block text-white hover:text-blue-200" onClick={toggleMenu}>
              <Video size={18} className="inline mr-2" />
              {t("header.videos")}
            </Link>

            {user ? (
              <>
                <Link
                  to={user.is_admin ? "/admin" : "/dashboard"}
                  className="block text-white hover:text-blue-200"
                  onClick={toggleMenu}
                >
                  <User size={18} className="inline mr-2" />
                  {user.is_admin ? t("header.adminPanel") : t("header.dashboard")}
                </Link>
                <button
                  onClick={handleLogout}
                  className="block text-white hover:text-blue-200 w-full text-left"
                >
                  <LogOut size={18} className="inline mr-2" />
                  {t("header.logout")}
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="block text-white hover:text-blue-200" onClick={toggleMenu}>
                  {t("header.login")}
                </Link>
                <Link
                  to="/register"
                  className="block bg-blue-500 px-4 py-2 rounded hover:bg-blue-400"
                  onClick={toggleMenu}
                >
                  {t("header.register")}
                </Link>
              </>
            )}

            <SimpleLanguageSwitcher />
          </div>
        )}
      </div>
    </header>
  )
}

export default Header
